var alignment_rtlignore_default = {
  "alignLeft": "_8Seay",
  "textWrapNowrap": "ZkpOx",
  "alignRight": "_64RFu",
  "alignCenter": "m-AaS",
  "sizeFullWidth": "_3n2HK",
  "renderedInTable": "_2mmS9",
  "sizeOriginal": "nEtHt",
  "sizeContent": "f2NoN",
  "sizeSmall": "b1Rn3",
  "sizeSmallCenter": "NvNW5",
  "flex": "xfKTM",
  "LEFT": "W9diT",
  "CENTER": "hfmvF",
  "RIGHT": "A7r-L",
  "AUTO": "feWr-",
  "JUSTIFY": "SzirY"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
